<script>

    import { toast } from 'bulma-toast'
    import { userStore, creditsStore, modalStore, adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import CreditsService from '../$services/credits.service'
    import DateMethods from '../$methods/date.methods'
    import TranslateMethods from '../$methods/translate.methods'
    import NumeralMethods from '../$methods/numeral.methods'

    import ButtonModal from '../$components/button.modal.svelte'
    import Select from '../$components/select.svelte'
    import Search from '../$components/input.search.svelte'
    import Table from '../$components/table.svelte'
    import Button from '../$components/button.svelte'

    export let all = false

    let loading = false
    let metadata = {}
    let query = {
        page: 0,
        find: null,
    }

    $: skeletonCols = all ? 7 : 6

    getCredits()

    async function getCredits() {

        if(all)
            query.admin = true
        else
            query.userId = $userStore._id

        loading = true
        const resp = await CreditsService.getCredits(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        creditsStore.set(resp.data.credits)
        metadata = resp.data.metadata
    }

</script>

<Table
    items={ $creditsStore.length }
    total={ metadata.total }
    { loading }
    { skeletonCols }
    bind:metadata
    bind:page={ query.page }
    on:change={ getCredits }
>
    <div slot="header" class="header-filters">
        <div class="header-top">
            <Search bind:value={ query.find } on:enter={ getCredits } />
            {#if all && isPermission($adminStore, 'TracingsView.Credit.Report')}
                <Button on:click={() => modalStore.set('credits_report_modal')} icon="file-excel" text="Descargar reporte" />
            {/if}
            {#if !all}
                <ButtonModal modalId="credit_create_modal" text="Agregar" icon="plus" />
            {/if}
        </div>
        {#if all}
            <div class="header-actions">
                <Select bind:value={ query.status } on:change={ getCredits }
                    text="Estatus de pago"
                    size="small"
                    options={[
                        {value: 'pending', text: 'Pendiente'},
                        {value: 'paid', text: 'Pagado'},
                        {value: 'free', text: 'Gratis'},
                    ]}
                />
            </div>
        {/if}
    </div>
    <thead slot="thead">
        <tr>
            <th>#</th>
            {#if all}
                <th>
                    <span class="icon-text">
                        <span class="icon"><i class="fas fa-user"></i></span>
                        <span>Usuario</span>
                    </span>
                </th>
            {/if}
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-clipboard-check"></i></span>
                    <span>Estatus</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-dollar-sign"></i></span>
                    <span>Monto</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-hashtag"></i></span>
                    <span>Referencia</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-calendar"></i></span>
                    <span>Fecha</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-ellipsis-v"></i></span>
                    <span>Acciones</span>
                </span>
            </th>
        </tr>
    </thead>
    <tbody slot="tbody">
        {#each $creditsStore as credit, index}
            <tr>
                <td><span>{ metadata?.items != null ? (metadata.items * (query.page ?? 0)) + (index + 1) : index + 1 }</span></td>
                {#if all}
                    <td>
                        <div class="td-stack">
                            <div>{ credit.user?.name }</div>
                            <small>{ credit.user?.email }</small>
                        </div>
                    </td>
                {/if}
                <td>{ TranslateMethods.get(credit.status) }</td>
                <td>{ NumeralMethods.cash(credit.amount) }</td>
                <td>{ credit.reference }</td>
                <td>{ DateMethods.dateLarge(credit.created) }</td>
                <td>
                    <Button on:click={() => modalStore.open('credit', 'modal', credit)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>
